import {
  EASYBIB,
  CITATION_MACHINE,
  BIBME,
  CHEGG,
  CITE_THIS_FOR_ME,
  OAProfileCode,
} from '@chegg-wt/core/constants/site'

export const getProfileCode = (site: string): string => {
  switch (site) {
    case EASYBIB:
      return OAProfileCode.EASYBIB
    case CITATION_MACHINE:
      return OAProfileCode.CITATION_MACHINE
    case BIBME:
      return OAProfileCode.BIBME
    case CITE_THIS_FOR_ME:
      return OAProfileCode.CITE_THIS_FOR_ME
    case CHEGG:
      return OAProfileCode.CHEGG
    default:
      break
  }
}
